import React from 'react';
import styles from './About.module.css';
import { LuChefHat, LuUtensils, LuTruck } from "react-icons/lu";

const About = () => {
  return (
    <section id="about" className={styles.about}>
      {/* Decorative Background Elements */}
      <div className={styles.decorativeCircle}></div>
      <div className={styles.decorativeBlob}></div>

      <div className={styles.container}>

        {/* LEFT CONTENT */}
        <div className={styles.content}>
          <div className={styles.headerBadge}>Rajkot's Finest</div>
          <h2 className={styles.title}>
            Welcome to <span className={styles.brandName}>Janki's</span> Cloud Kitchen
          </h2>

          <div className={styles.textBox}>
            <p className={styles.gujaratiText}>
              <span className={styles.highlight}>સ્વાદના શોખીનો માટેનું શ્રેષ્ઠ સ્થળ...</span>
            </p>
            <p className={styles.descriptionText}>
              રાજકોટમાં પ્રથમ વખત, અમે લાવ્યા છીએ અનોખા ટેસ્ટનો ખજાનો! 
              અમારે ત્યાં <span className={styles.goldHighlight}>શુદ્ધ સીંગતેલ</span> માં બનેલી 
              <b> મકાઈ મુઠડી, મલાઈ દો પ્યાજ, ભરેલા પાપડ, અને કાજુ ગાંઠીયા</b> જેવી વેરાઈટીઓ મળશે.
            </p>
            <p className={styles.descriptionText}>
               અમારો ઉદ્દેશ્ય માત્ર જમવાનું આપવાનો નથી, પણ <b>"ઘર જેવો શુદ્ધ સ્વાદ"</b> પહોંચાડવાનો છે.
            </p>
          </div>

          <div className={styles.taglineBox}>
            <span className={styles.quoteMark}>❝</span>
            <p>એક વાર ઓર્ડર કરો… રોજ યાદ આવે એવો સ્વાદ મળશે!</p>
          </div>

          <div className={styles.highlights}>
            <div className={styles.point}>
              <div className={styles.iconBox}><LuUtensils /></div>
              <div className={styles.pointText}>
                <h4>શુદ્ધ સીંગતેલ</h4>
                <span>Cooked in Pure Groundnut Oil</span>
              </div>
            </div>

            <div className={styles.point}>
               <div className={styles.iconBox}><LuChefHat /></div>
              <div className={styles.pointText}>
                <h4>કાઠીયાવાડી સ્પેશિયલ</h4>
                <span>Vagharelo Rotlo & More</span>
              </div>
            </div>

            <div className={styles.point}>
               <div className={styles.iconBox}><LuTruck /></div>
              <div className={styles.pointText}>
                <h4>બલ્ક ઓર્ડર</h4>
                <span>Catering for 15-25+ People</span>
              </div>
            </div>
          </div>

          <div className={styles.ownerCard}>
            {/* You can replace this src with Jalpa's real photo if you have it */}
            <img 
              src="https://img.freepik.com/premium-photo/indian-woman-cooking-kitchen-chef-restaurant-generative-ai_779468-2432.jpg" 
              alt="Owner" 
              className={styles.ownerAvatar} 
            />
            <div className={styles.ownerInfo}>
              <p className={styles.ownerLabel}>Head Chef & Owner</p>
              <p className={styles.ownerName}>Jalpa Vasani</p>
            </div>
          </div>
        </div>

        {/* RIGHT VISUAL GRID - Updated with Food Images */}
        <div className={styles.visualSide}>
          <div className={styles.imageGrid}>
            
            {/* Image 1: Main Dish (Paneer/Curry) */}
            <div className={`${styles.imageCard} ${styles.card1}`}>
              <img 
                src="https://media.istockphoto.com/id/1156130293/photo/group-of-gujarati-snacks-like-jalebi-fafda-thepla-khaman-dhokla-aloo-bhujiya-khandvi-khakra.jpg?s=612x612&w=0&k=20&c=aUBFopzsLwLQtPRv-QgLa26-EfCJi5qxO6O3kxHPolY=" 
                alt="Malai Do Pyaza" 
              />
              <div className={styles.imgOverlay}>Premium Taste</div>
            </div>

            {/* Image 2: Breads/Rotlo */}
            <div className={`${styles.imageCard} ${styles.card2}`}>
              <img 
                src="https://thumbs.dreamstime.com/b/traditional-indian-thali-gujarati-meal-thaali-consisting-different-curries-like-sev-tomato-na-shak-aloo-gobhi-cauliflower-109346611.jpg" 
                alt="Kathiyawadi Rotlo" 
              />
              <div className={styles.imgOverlay}>Desi Swad</div>
            </div>

            {/* Image 3: Ingredients/Spices */}
            <div className={`${styles.imageCard} ${styles.card3}`}>
              <img 
                src="https://media.istockphoto.com/id/1173495885/photo/bhelpuri-an-indian-delicious-food-chaat-or-snack.jpg?s=612x612&w=0&k=20&c=Bvoic28QePizgvmF0qNviexg3pJxuiyySSFZYAj2qkE=" 
                alt="Pure Spices" 
              />
              <div className={styles.imgOverlay}>Pure Quality</div>
            </div>

            {/* Image 4: Thali/Platter */}
            <div className={`${styles.imageCard} ${styles.card4}`}>
              <img 
                src="https://thumbs.dreamstime.com/b/bedmi-aloo-sabji-poori-spicy-58973232.jpg" 
                alt="Full Thali" 
              />
              <div className={styles.imgOverlay}>Healthy</div>
            </div>

          </div>

          {/* Floating Badge */}
          <div className={styles.floatingBadge}>
            <span>Fresh</span> Daily
          </div>

        </div>

      </div>
    </section>
  );
};

export default About;